import { useState, useMemo, useCallback, useEffect } from "react";
const useScreenDetector = (mobileMaxWidth = 768, tabletMaxWidth = 1024) => {
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const isMobile = useMemo(() => width <= mobileMaxWidth, [width, mobileMaxWidth]);
    const isTablet = useMemo(() => width <= tabletMaxWidth && width > mobileMaxWidth, [width, tabletMaxWidth, mobileMaxWidth]);
    const isDesktop = useMemo(() => width > tabletMaxWidth, [width, tabletMaxWidth]);
    const handleWindowSizeChange = useCallback(() => {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
    }, []);
    useEffect(() => {
        window.addEventListener("resize", handleWindowSizeChange);
        return () => {
            window.removeEventListener("resize", handleWindowSizeChange);
        };
    }, [handleWindowSizeChange]);
    return {
        width,
        height,
        isMobile,
        isTablet,
        isDesktop,
    };
};
export default useScreenDetector;
